import { render, staticRenderFns } from "./ProductReceipt.vue?vue&type=template&id=f1011c58&"
import script from "./ProductReceipt.vue?vue&type=script&lang=js&"
export * from "./ProductReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports